export const Blue300 = '#8AD1F5'
export const Blue600 = '#45798E'
export const Green500 = '#71C09D'
export const Green600 = '#59B18A'
export const Red800 = '#DD5471'
